/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_RowInputs */

const vi_import_row = /** @type {(inputs: Import_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng`)
};

/**

* @param {Import_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_row = /** @type {((inputs?: Import_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_RowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_row(inputs)
});